import { SVGProps } from "react"

const ExclamationIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M40.9572 28.5352L28.7062 4.70928C27.176 1.80348 24.2645 0 21.1036 0C17.9428 0 15.0313 1.80348 13.501 4.70928L1.05453 28.5124C-0.407771 31.3394 -0.345592 34.7664 1.2182 37.5328C2.78199 40.2992 5.61643 41.9964 8.67884 42H33.3112C36.371 42 39.2052 40.3092 40.7729 37.5484C42.3406 34.7877 42.4106 31.3641 40.9572 28.5352ZM19.2356 15.3899C19.2356 14.4445 19.965 13.6782 20.8647 13.6782C21.7644 13.6782 22.4938 14.4445 22.4938 15.3899V22.4418C22.4938 23.3871 21.7644 24.1534 20.8647 24.1534C19.965 24.1534 19.2356 23.3871 19.2356 22.4418V15.3899ZM20.8864 30.7945C21.7862 30.7945 22.5155 30.0282 22.5155 29.0829L22.4938 29.0601C22.4938 28.1274 21.7742 27.3713 20.8864 27.3713C19.9916 27.3836 19.269 28.1427 19.2573 29.0829C19.2573 30.0282 19.9867 30.7945 20.8864 30.7945Z"
        fill="#0000FA"
      />
    </svg>
  )
}

export default ExclamationIcon
